import { createSlice } from "@reduxjs/toolkit";
import { APP_VERSION } from "../../constant";

const initialState = {
  cartItems: 0,
  notificationCount: 0,
  currentMenu: "",
  collapsed: false,
  offerList: [],
  appVersion: APP_VERSION,
};

const navCounts = createSlice({
  name: "navCounts",
  initialState,
  reducers: {
    setCounts: (state, action) => {
      const { cartItems, notificationCount, appVersion } = action.payload;
      if (cartItems !== undefined) state.cartItems = cartItems;
      if (notificationCount !== undefined) state.notificationCount = notificationCount;
      if (appVersion !== undefined) state.appVersion = appVersion;
    },
    changeCurrentMenu: (state, action) => {
      state.currentMenu = action.payload;
    },
    resetNavState: () => initialState,
    setCollapsedSide: (state, action) => {
      state.collapsed = action.payload;
    },
    setOfferList: (state, action) => {
      state.offerList = action.payload;
    },
  },
});

export const { setCounts, resetNavState, changeCurrentMenu, setCollapsedSide, setOfferList } = navCounts.actions;
export default navCounts.reducer;
